export default __webpack_public_path__ + "static/media/zoho-logo.e192ff31.svg";